import { createRouter, createWebHashHistory } from "vue-router";
import jsCookie from "js-cookie";

export const routes = [
  {
    path: "/",
    mame: "index",
    component: () => import("../views/Index.vue"),
  },
  // 替代vue2中的'*'通配符路径
  {
    path: "/:pathMatch(.*)*",
    redirect: "/",
  },
  {
    path: "/wx_auth",
    name: "wx_auth",
    component: () => import("../views/WechatAuth.vue"),
  },
  {
    path: "/zsplus_auth",
    name: "zsplus_auth",
    component: () => import("../views/ZsplusAuth.vue"),
  },
  {
    path: "/wx_guide",
    name: "wx_guide",
    component: () => import("../views/WechatGuide.vue"),
  },
  {
    path: "/locations/:categoryId",
    name: "locations",
    component: () => import("../views/Locations.vue"),
  },

  {
    path: "/detail/:locationId",
    name: "detail",
    component: () => import("../views/Detail.vue"),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const userAgentString = navigator.userAgent.toLowerCase();
  if (userAgentString.indexOf("zsrbapp") >= 0) {
    console.log("into zsrbapp env");
    // 校验中山+存储的授权信息
    const zsplusInfo = sessionStorage.getItem("zsplusInfo");
    const token = jsCookie.get("token");

    if (!token && to.name !== "zsplus_auth") {
      next({
        name: "zsplus_auth",
      });
    } else if (!zsplusInfo && to.name !== "zsplus_auth") {
      next({
        name: "zsplus_auth",
      });
    } else {
      next();
    }
  } else if (userAgentString.indexOf("micromessenger") >= 0) {
    const token = jsCookie.get("token");
    // 没有用户信息（即未进行微信授权）
    if (!token && to.path !== "/wx_auth") {
      // 微信授权获取用户信息指定的路径
      const redirect_uri = encodeURIComponent(
        `https://zsrbactivity.zsnews.cn/vue/foodstreet/#/wx_auth`
      );
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx2d1b0208e6e6741f&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo#wechat_redirect`;
    } else {
      next();
    }
  } else {
    //有了用户信息直接跳转
    next();
  }
  next();
});

export default router;
